import { useRadio, Box, Stack } from '@chakra-ui/react';

export default function RadioCard(props) {
    const { getInputProps, getRadioProps } = useRadio(props);

    const input = getInputProps();
    const checkbox = getRadioProps();

    return (
        <Box as='label' flex='1'>
            <input {...input} />
            <Stack
                {...checkbox}
                cursor='pointer'
                borderWidth='2px'
                borderRadius='md'
                boxShadow='md'
                _checked={{
                    borderColor: 'black',
                }}
                _focus={{
                    boxShadow: 'outline',
                }}
                _hover={{ bgColor: 'gray.100' }}
                px={5}
                py={3}
                justifyContent='center'
                alignItems='center'
                spacing='0'
            >
                {props.children}
            </Stack>
        </Box>
    );
}
